import './locales/register'
import { lazy } from 'react'
import { useParams, type RouteObject } from 'react-router-dom'

const List = lazy(() => import('./components/List'))
const Create = lazy(() => import('./components/Create'))
const Detail = lazy(() => import('./components/Detail'))

const DetailRoute = () => {
    const { paymentID } = useParams()
    return <Detail key={paymentID} />
}

const PurchasingPaymentsModule: RouteObject = {
    path: 'purchasing-payments',
    children: [
        { path: 'purchase', element: <List key="purchase" type="purchase" /> },
        { path: 'advance', element: <List key="advance" type="advance" /> },
        { path: 'expense', element: <List key="expense" type="expense" /> },
        { path: ':type/new', element: <Create /> },
        { path: 'requests/:paymentID', element: <DetailRoute /> },
    ],
}
export default PurchasingPaymentsModule
